// extracted by mini-css-extract-plugin
export default {"overlay":"StripeModal_overlay__9AdiS","modal":"StripeModal_modal__l3lEz"};